import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { AdminFeeDrawer } from './admin-fee-drawer.component'

export interface AdminFeeDrawerContextProps {
  showAdminFeeDrawer: boolean
  setShowAdminFeeDrawer: Dispatch<SetStateAction<boolean>>
}

export const AdminFeeDrawerContext = createContext<AdminFeeDrawerContextProps>({
  showAdminFeeDrawer: false,
  setShowAdminFeeDrawer: () => null,
})

export const useAdminFeeDrawer = () => useContext(AdminFeeDrawerContext)

interface AdminFeeDrawerProviderProps {
  children: React.ReactNode
}

const AdminFeeDrawerProvider: React.FC<AdminFeeDrawerProviderProps> = ({
  children,
}) => {
  const [showAdminFeeDrawer, setShowAdminFeeDrawer] = useState<boolean>(false)

  return (
    <AdminFeeDrawerContext.Provider
      value={{ showAdminFeeDrawer, setShowAdminFeeDrawer }}
    >
      <AdminFeeDrawer />
      {children}
    </AdminFeeDrawerContext.Provider>
  )
}

export { AdminFeeDrawerProvider }
